/* @flow */

import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import LocaleUtil from "shared/src/uidispatcherapi/LocaleUtil";

import { GdprStorage } from "shared/src/uidispatcherapi/GdprStorage";

import { Store } from "shared/src/stores/Store";

import { postRelevanceJudgment } from "../clients/SearchCockpitClient";

import SearchResultStore from "./SearchResultStore";
import Tracking from "shared/src/uidispatcherapi/Tracking";

export class RelevanceJudgmentStoreImpl extends Store {
    constructor() {
        super();
    }

    async postJudgment(articleVariantId: string, judgment: boolean) {
        const country = CountryUtil.getCountry();
        const locale = LocaleUtil.getLocale();
        const query = this.getQuery();
        if (!query) {
            return;
        }
        const judgmentInt = judgment ? 100 : -100;
        const data = {
            country,
            locale,
            query,
            articleVariantId,
            judgment: judgmentInt
        };
        const key = `sd_judgment_${country}_${locale}_${query}_${articleVariantId}`;
        GdprStorage.localStorage.put(key, String(judgmentInt), GdprStorage.FUNCTIONAL);
        this.trigger();

        try {
            await postRelevanceJudgment(data);
        } catch (e: any) {
            Tracking.trackError(
                "searchdiscover",
                "ui",
                "RelevanceJudgementStore",
                "Error posting relevance judgment:",
                e
            );
            GdprStorage.localStorage.remove(key);
        }
    }

    getJudgment(articleVariantId: string): boolean | undefined {
        const country = CountryUtil.getCountry();
        const locale = LocaleUtil.getLocale();
        const query = this.getQuery();
        if (!query) {
            return undefined;
        }
        const judgmentStr = GdprStorage.localStorage.get(
            `sd_judgment_${country}_${locale}_${query}_${articleVariantId}`
        ).actualResult;
        if (!judgmentStr) {
            return undefined;
        }
        return Number(judgmentStr) > 0;
    }

    getQuery(): string | undefined | null {
        const searchResult = SearchResultStore.getState();
        return searchResult && searchResult.q && searchResult.q.toLowerCase().trim();
    }
}

export const RelevanceJudgmentStore = new RelevanceJudgmentStoreImpl();
